import PropTypes from 'prop-types';
import React from 'react';

import {STAGE_RUN_FULL_SHAPE, StageRun} from 'workflows/WorkflowConstants';

import ActionCell from './ActionCell';
import {InputType} from './ExternalInputPicker';
import SharedInputTableRow from './SharedInputTableRow';

interface EmptyInputTableRowProps {
  checkboxCell: JSX.Element;
  experimentalConditionValueNames: Array<string>;
  stageRun: StageRun;
  locked: boolean;
  onOpenAddInputSampleModal: (stageRunId: string, inputType: InputType | null) => void;
}

/**
 * Input table row for a stage run with no inputs and no parents. This allows you to set up the
 * stage run by searching for a batch or container as a starting point.
 */
class EmptyInputTableRow extends React.Component<EmptyInputTableRowProps> {
  static propTypes = {
    checkboxCell: PropTypes.node.isRequired,
    experimentalConditionValueNames: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    stageRun: STAGE_RUN_FULL_SHAPE.isRequired,
    locked: PropTypes.bool.isRequired,
    // Function accepting (stageRunId, inputType) that opens the modal.
    onOpenAddInputSampleModal: PropTypes.func.isRequired,
  };

  _renderSampleCell(): JSX.Element {
    const {stageRun, locked} = this.props;
    if (locked) {
      return <div className="workflowDetailsTable-missingCellValue">None</div>;
    }
    return (
      <ActionCell
        icon="search"
        onClick={() => {
          this.props.onOpenAddInputSampleModal(stageRun.id, null);
        }}
      >
        <div className="workflowDetailsTable-missingCellValue">None</div>
      </ActionCell>
    );
  }

  _renderContainerCell(): JSX.Element {
    const {stageRun, locked} = this.props;
    if (locked) {
      return <span className="workflowDetailsTable-missingCellValue">None</span>;
    }
    return (
      <ActionCell
        icon="search"
        onClick={() => {
          this.props.onOpenAddInputSampleModal(stageRun.id, InputType.CONTAINER);
        }}
      >
        <span className="workflowDetailsTable-missingCellValue">None</span>
      </ActionCell>
    );
  }

  render(): JSX.Element {
    return (
      <SharedInputTableRow
        checkboxCell={this.props.checkboxCell}
        experimentalConditionValueNames={this.props.experimentalConditionValueNames}
        sampleCellContents={this._renderSampleCell()}
        containerCellContents={this._renderContainerCell()}
        stageRun={this.props.stageRun}
      />
    );
  }
}

export default EmptyInputTableRow;
